export default {
  eca_rule: {
    sheet: '张'
  }
}
